import Vue from 'vue'
import SvgIcon from '@/components/icons/SvgIcon'// svg component
// register globally
Vue.component('svg-icon', SvgIcon)
// require.contex（目标目录，是否扫描子目录，正则） 扫描目录中的文件
const req = require.context('../img/svgIcon', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
// map循环每一项 svg图片，req函数能够引用图片到项目中
requireAll(req) // 调用函数，将所有的svg都引用到项目中